import type { Apartment } from '@/types/apartment';

export function formatMoney(value: number): string {
  return `$${Math.round(value).toLocaleString('es-CO')}`;
}

export function formatRoundedUpToThousand(value: number): string {
  return formatMoney(Math.ceil(value / 1000) * 1000);
}

export function pluralize(value: number, singular: string, plural: string): string {
  return `${value} ${value === 1 ? singular : plural}`;
}

export interface ApartmentCardMetadataInput {
  tipo?: Apartment['tipo'] | 'estudio' | string;
  bedrooms?: number | null;
  guests: number;
  floor?: number | string | null;
  roomLabel?: string;
}

export function getApartmentCardMetadata({
  tipo,
  bedrooms,
  guests,
  floor,
  roomLabel,
}: ApartmentCardMetadataInput): string {
  const normalizedType = typeof tipo === 'string' ? tipo.toLowerCase() : '';
  const isStudio = normalizedType === 'studio' || normalizedType === 'estudio';
  const rooms =
    roomLabel ??
    (isStudio
      ? 'Estudio'
      : typeof bedrooms === 'number' && bedrooms > 0
        ? pluralize(bedrooms, 'habitación', 'habitaciones')
        : 'Apartamento');

  const parts = [rooms, pluralize(guests, 'persona', 'personas')];
  if (floor !== undefined && floor !== null && floor !== '') {
    parts.push(`Piso ${floor}`);
  }

  return parts.join(' · ');
}

export function getCarouselImages(apartment: Apartment): string[] {
  const candidates = [
    apartment.thumbnail,
    apartment.featuredImage,
    ...(apartment.images ?? []),
  ].filter((src): src is string => Boolean(src));

  return Array.from(new Set(candidates)).slice(0, 6);
}
